import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '@modules/shared.module';

@Component({
  selector: 'app-button-delete',
  standalone: true,
  imports: [MatIconModule,MatButtonModule],
  template: `<div class="button-container"><button mat-stroked-button color="warn" [disabled]="disabled" name="Eliminar">
  <mat-icon>delete</mat-icon> Eliminar
</button></div>`,
  styleUrls: ['./button-delete.component.css'],
})
export class ButtonDeleteComponent {
  @Input() disabled! : any
}
